import Accordion from '@/components/generics/Accordion'
import { HexaV2Icon } from '@/components/hexa-v2'
import { hexaBaseIcon, HexaIcons } from '@/resources/enums/hexaIcons'
import { useEffect, useState } from 'react'
import { HexaV2AccordionProps } from './types'
import * as S from './styles'

const HexaV2Accordion = ({
  id,
  header,
  children,
  onChange,
  margin,
  isOpen = false,
  hasArrow = true,
}: HexaV2AccordionProps) => {
  const getArrow = () =>
    arrowOpen ? HexaIcons.CHEVRON_UP : HexaIcons.CHEVRON_DOWN

  const [arrowOpen, setArrowOpen] = useState<boolean>(isOpen)

  useEffect(() => {
    setArrowOpen(isOpen)
  }, [isOpen])

  return (
    <S.Wrapper>
      <Accordion
        id={id}
        header={header}
        body={children}
        accordionShow={isOpen}
        onAccordionChange={(show: boolean) => {
          setArrowOpen(show)
          onChange?.(show)
        }}
        margin={margin ?? 'var(--space-5) var(--space-0)'}
      />
      {hasArrow && (
        <S.IconWrapper>
          <HexaV2Icon
            icon={hexaBaseIcon(getArrow())}
            size="small"
            className="accordion-arrow-icon"
          />
        </S.IconWrapper>
      )}
    </S.Wrapper>
  )
}

export default HexaV2Accordion
